import apiClient from './apiClient';
import { TrainingData } from '../../types/trainingData';

export const getTraining = async (): Promise<Array<TrainingData>> => {
    try {
        const response = await apiClient.get('/trainings');

        const rawTrainings = response.data.data;

        return rawTrainings;
    } catch (error) {
        console.error('Error fetching trainings:', error);
        return [];
    }
};

export const createTraining = async (training: TrainingData): Promise<TrainingData> => {
    try {
        const response = await apiClient.post('/trainings', training);

        return response.data;
    } catch (error) {
        console.error('Error creating training:', error);
        return training;
    }
};
